import { render, staticRenderFns } from "./ship-outline.svg.vue?vue&type=template&id=5b5f130d&"
import script from "./ship-outline.svg.vue?vue&type=script&lang=js&"
export * from "./ship-outline.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports